import {applySnapshot, getSnapshot} from "mobx-state-tree"


const localstorable = (config) => (self) => {

    const afterLoad  = config.afterLoad ? (data) => config.afterLoad(data) : data => data;
    return ({
        actions: {
            getItems () {
                console.log("get-items -sefl ", self)
                try {
                    applySnapshot(self['dashboardItems'], afterLoad(
                        JSON.parse(window.localStorage.getItem(config.path)) ||
                        config.default))
                } catch (e) {
                    console.log('err', window.localStorage.getItem(config.path))
                    applySnapshot(self['dashboardItems'], afterLoad(config.default))
                    console.error('no loadable')
                }
            },
            setItems () {
                console.log("tts", getSnapshot(self.dashboardItems))
                window.localStorage.setItem(config.path, JSON.stringify(getSnapshot(self.dashboardItems)))
            }
        }
    })
}

export default localstorable


